var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _c("div", { staticClass: "form-inline" }, [
            _c(
              "button",
              {
                staticClass: "btn-info btn--bigger",
                attrs: { type: "button" },
                on: { click: _vm.botonConsultar }
              },
              [
                _c("i", { staticClass: "fa fa-search" }),
                _vm._v(" "),
                _c("span", [_vm._v("Consultar")])
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-success btn--bigger",
                attrs: { type: "button" },
                on: { click: _vm.botonNuevo }
              },
              [
                _c("i", { staticClass: "fa fa-plus" }),
                _vm._v(" "),
                _c("span", [_vm._v("Nuevo")])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "details",
        { staticClass: "card card--collapsible mt-2", attrs: { open: "" } },
        [
          _vm._m(1),
          _vm._v(" "),
          _c("div", { staticClass: "card__content" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-xs-12 col-md-4" }, [
                _c("div", { staticClass: "form-field select" }, [
                  _c(
                    "div",
                    { staticClass: "select-field select-field--stretch" },
                    [
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.estado,
                              expression: "form.estado"
                            }
                          ],
                          attrs: { id: "estado" },
                          on: {
                            change: [
                              function($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function(o) {
                                    return o.selected
                                  })
                                  .map(function(o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.$set(
                                  _vm.form,
                                  "estado",
                                  $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                )
                              },
                              _vm.changeEstado
                            ]
                          }
                        },
                        [
                          _c("option", { attrs: { value: "A" } }, [
                            _vm._v("ACTIVO")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "I" } }, [
                            _vm._v("INACTIVO")
                          ]),
                          _vm._v(" "),
                          _c("option", { attrs: { value: "T" } }, [
                            _vm._v("TODOS")
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "estado" } }, [
                        _vm._v("Estado")
                      ])
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-xs-12 col-md-8" }, [
                _c("div", { staticClass: "form-inline" }, [
                  _c(
                    "label",
                    { staticStyle: { color: "#435465", "font-weight": "700" } },
                    [_vm._v("Fecha:")]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-field" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "datepicker-field datepicker-field--stretch"
                      },
                      [
                        _c("VueCtkDateTimePicker", {
                          attrs: {
                            id: "fecha_desde",
                            locale: "es",
                            "only-datetime": "",
                            "no-label": "",
                            "button-now-translation": "Ahora",
                            format: "YYYY-MM-DD HH:mm",
                            formatted: "YYYY-MM-DD HH:mm",
                            label: "Seleccione fecha..."
                          },
                          model: {
                            value: _vm.form.fecha_desde,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "fecha_desde", $$v)
                            },
                            expression: "form.fecha_desde"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", [_vm._v("Desde")])
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-field" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "datepicker-field datepicker-field--stretch"
                      },
                      [
                        _c("VueCtkDateTimePicker", {
                          attrs: {
                            id: "fecha_hasta",
                            locale: "es",
                            "only-datetime": "",
                            "no-label": "",
                            "button-now-translation": "Ahora",
                            format: "YYYY-MM-DD HH:mm",
                            formatted: "YYYY-MM-DD HH:mm",
                            label: "Seleccione fecha..."
                          },
                          model: {
                            value: _vm.form.fecha_hasta,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "fecha_hasta", $$v)
                            },
                            expression: "form.fecha_hasta"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", [_vm._v("Hasta")])
                      ],
                      1
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-xs-12 col-md-5" },
                [
                  _c(
                    "input-field",
                    {
                      attrs: {
                        stretchMd: "",
                        id: "search",
                        placeholder: "Consulta contenido..."
                      },
                      on: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.botonConsultar()
                        }
                      },
                      model: {
                        value: _vm.form.search,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "search", $$v)
                        },
                        expression: "form.search"
                      }
                    },
                    [_c("span", [_vm._v("Consulta:")])]
                  )
                ],
                1
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _vm.registros.length
        ? _c(
            "details",
            { staticClass: "card card--collapsible mt-2", attrs: { open: "" } },
            [
              _vm._m(2),
              _vm._v(" "),
              _vm.registros.length
                ? _c("listaTerminosCondiciones", {
                    ref: "listaTerminosCondiciones",
                    attrs: { propRegistros: _vm.registros, propForm: _vm.form },
                    on: {
                      consultar: _vm.consultarPagina,
                      editar: _vm.botonEditar,
                      eliminar: _vm.botonEliminar,
                      descargarPdf: _vm.botonDescargarPdf
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "terminosCondiciones",
            width: "80%",
            clickToClose: false,
            height: "auto",
            scrollable: ""
          }
        },
        [
          _c("terminosCondiciones", {
            attrs: { propTerminosCondiciones: _vm.terminos_condiciones },
            on: { cargarFila: _vm.cargarFila }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Términos y condiciones")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "summary",
      { staticClass: "card__title card__title--bg-primary" },
      [_c("h5", [_vm._v("Filtros de búsqueda")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "summary",
      { staticClass: "card__title card__title--bg-primary" },
      [_c("h5", [_vm._v("Lista")])]
    )
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2fd4423a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2fd4423a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/terminos-condiciones/ConsultaTerminosCondiciones.vue
// module id = 630
// module chunks = 0